export default function logoutAndRedirect() {
  localStorage.removeItem("user");
  localStorage.clear();
  window.location.href = "/authentication/sign-in";
}
